// LQIP (Low Quality Image Placeholder) blur-up effect
// @param {Element} container - Optional container to scope the search (defaults to document)
function initLQIP(container) {
  const scope = container || document;
  // Only process images that haven't been initialized yet
  const lqipImages = scope.querySelectorAll('.media-lqip[data-lqip]:not([data-lqip-initialized])');
  
  lqipImages.forEach(function(img) {
    // Mark as initialized to avoid re-processing
    img.setAttribute('data-lqip-initialized', 'true');
    
    // Set LQIP as background immediately for instant visual feedback
    const lqipSrc = img.getAttribute('data-lqip');
    const mediaContainer = img.closest('.media-container') || img.parentElement;
    
    if (lqipSrc && mediaContainer) {
      // Preload LQIP for instant display
      const lqipImg = new Image();
      lqipImg.src = lqipSrc;
      
      // Set background immediately (LQIP is tiny, loads almost instantly)
      mediaContainer.style.backgroundImage = 'url(' + lqipSrc + ')';
      mediaContainer.style.backgroundSize = 'cover';
      mediaContainer.style.backgroundPosition = 'center';
      mediaContainer.style.backgroundRepeat = 'no-repeat';
    }
    
    // When main image loads, remove blur and fade in
    const handleImageLoad = function() {
      img.classList.add('loaded');
      // Clean up background image once main image is loaded (memory optimization)
      if (mediaContainer && mediaContainer.style.backgroundImage) {
        mediaContainer.style.backgroundImage = '';
      }
    };
    
    if (img.complete && img.naturalWidth > 0) {
      // Image already loaded
      handleImageLoad();
    } else {
      // Wait for image to load
      img.addEventListener('load', handleImageLoad, { once: true });
      
      // Also handle error case
      img.addEventListener('error', function() {
        // Remove blur even on error to show fallback
        handleImageLoad();
      }, { once: true });
      
      // Fallback: remove blur after timeout even if load event doesn't fire
      setTimeout(function() {
        if (!img.classList.contains('loaded')) {
          handleImageLoad();
        }
      }, 3000);
    }
  });
}

function handleDraggableObjects() {
  $(".draggable-object").draggable({
    iframeFix: true,
    start: function(event, ui) {
      event.target.style.transform = 'translate(0px, 0px)';
    }
  });
}

function handleMobileNav() {
  const mobileNavButton = document.querySelector('.nav-menu-mobile-button');
  mobileNavButton?.addEventListener('click', function () {
    const body = document.querySelector('body');
    body.classList.toggle('mobile-nav-open');
    if (body.classList.contains('mobile-nav-open')) {
      mobileNavButton.innerHTML = 'Close';
    } else {
      mobileNavButton.innerHTML = 'Menu';
    }
  });
}

function setMainPaddingForFooter() {
  const footer = document.querySelector('#footer');
  const root = document.documentElement;
  
  if (!footer) return;
  
  function updatePadding() {
    const footerHeight = footer.offsetHeight;
    root.style.setProperty('--footer-height', footerHeight + 'px');
  }
  
  // Initial calculation
  updatePadding();
  
  // Recalculate on resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updatePadding, 100);
  });
  
  // Recalculate when content changes (for dynamic content)
  const observer = new MutationObserver(function() {
    updatePadding();
  });
  
  observer.observe(footer, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initLQIP();
  handleDraggableObjects();
  handleMobileNav();
  setMainPaddingForFooter();
});